export default __webpack_public_path__ + "static/media/rings4.78621b59.png";